import {SECTION_ROUTE_MAP} from '../constants/section-mapping'

export const getRouteConfigForSection = (sectionName: string): string | null => {
  if (typeof SECTION_ROUTE_MAP[sectionName] !== 'undefined') {
    return SECTION_ROUTE_MAP[sectionName]
  }
  return null
}
